import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cellphone-modal"
export default class extends Controller {
  static targets = [ "modal" ]

  connect() {
    this.open();
  }

  open() {
    if(this.hasModalTarget){
      const modal = new bootstrap.Modal(this.modalTarget)
      modal.show()
    }
  }

  close() {
    if(this.hasModalTarget){
      const modal = new bootstrap.Modal(this.modalTarget)
      modal.hide()
    }
  }
}
